;(function($) {
  $.ui.plugin.add('draggable', 'smartguides', {
    start: function(event, ui) {
      var i = $(this).data('ui-draggable'),
        o = i.options
      i.elements = []
      $(
        o.smartguides.constructor != String
          ? o.smartguides.items || ':data(draggable)'
          : o.smartguides
      ).each(function() {
        var $t = $(this)
        var $o = $t.offset()
        if (this != i.element[0]) {
          i.elements.push({
            item: this,
            width: $t.outerWidth(),
            height: $t.outerHeight(),
            top: $o.top,
            left: $o.left
          })
        }
      })
    },
    stop: function(event, ui) {
      $('.objectx').css({display: 'none'})
      $('.objecty').css({display: 'none'})
    },
    drag: function(event, ui) {
      var inst = $(this).data('ui-draggable'),
        o = inst.options
      var d = o.tolerance
      $('.objectx').css({display: 'none'})
      $('.objecty').css({display: 'none'})
      var x1 = ui.offset.left,
        x2 = x1 + inst.helperProportions.width,
        y1 = ui.offset.top,
        y2 = y1 + inst.helperProportions.height,
        xc = (x1 + x2) / 2,
        yc = (y1 + y2) / 2
      for (var i = inst.elements.length - 1; i >= 0; i--) {
        var l = inst.elements[i].left,
          r = l + inst.elements[i].width,
          t = inst.elements[i].top,
          b = t + inst.elements[i].height,
          hc = (l + r) / 2,
          vc = (t + b) / 2
        var lss = Math.abs(l - x1) <= d
        var ls = Math.abs(l - x2) <= d
        var rss = Math.abs(r - x2) <= d
        var rs = Math.abs(r - x1) <= d
        var tss = Math.abs(t - y1) <= d
        var ts = Math.abs(t - y2) <= d
        var bss = Math.abs(b - y2) <= d
        var bs = Math.abs(b - y1) <= d
        var hs = Math.abs(hc - xc) <= d
        var vs = Math.abs(vc - yc) <= d
        if (lss) {
          ui.position.left =
            inst._convertPositionTo('relative', {top: 0, left: l}).left -
            inst.margins.left
          $('.objectx').css({left: ui.position.left, display: 'block'})
        }
        if (rss) {
          ui.position.left =
            inst._convertPositionTo('relative', {
              top: 0,
              left: r - inst.helperProportions.width
            }).left - inst.margins.left
          $('.objectx').css({
            left: ui.position.left + ui.helper.width(),
            display: 'block'
          })
        }
        if (ls) {
          ui.position.left =
            inst._convertPositionTo('relative', {
              top: 0,
              left: l - inst.helperProportions.width
            }).left - inst.margins.left
          $('.objectx').css({
            left: ui.position.left + ui.helper.width(),
            display: 'block'
          })
        }
        if (rs) {
          ui.position.left =
            inst._convertPositionTo('relative', {top: 0, left: r}).left -
            inst.margins.left
          $('.objectx').css({left: ui.position.left, display: 'block'})
        }
        if (tss) {
          ui.position.top =
            inst._convertPositionTo('relative', {top: t, left: 0}).top -
            inst.margins.top
          $('.objecty').css({top: ui.position.top, display: 'block'})
        }
        if (ts) {
          ui.position.top =
            inst._convertPositionTo('relative', {
              top: t - inst.helperProportions.height,
              left: 0
            }).top - inst.margins.top
          $('.objecty').css({
            top: ui.position.top + ui.helper.height(),
            display: 'block'
          })
        }
        if (bss) {
          ui.position.top =
            inst._convertPositionTo('relative', {
              top: b - inst.helperProportions.height,
              left: 0
            }).top - inst.margins.top
          $('.objecty').css({
            top: ui.position.top + ui.helper.height(),
            display: 'block'
          })
        }
        if (bs) {
          ui.position.top =
            inst._convertPositionTo('relative', {top: b, left: 0}).top -
            inst.margins.top
          $('.objecty').css({top: ui.position.top, display: 'block'})
        }
        if (hs) {
          ui.position.left =
            inst._convertPositionTo('relative', {
              top: 0,
              left: hc - inst.helperProportions.width / 2
            }).left - inst.margins.left
          $('.objectx').css({
            left: ui.position.left + ui.helper.width() / 2,
            display: 'block'
          })
        }
        if (vs) {
          ui.position.top =
            inst._convertPositionTo('relative', {
              top: vc - inst.helperProportions.height / 2,
              left: 0
            }).top - inst.margins.top
          $('.objecty').css({
            top: ui.position.top + ui.helper.height() / 2,
            display: 'block'
          })
        }
      }
    }
  })
  $('.dropped').draggable({
    containment: 'parent',
    smartguides: '.dropped',
    tolerance: 5
  })
})(jQuery)



//////////////////
// WEBPACK FOOTER
// ./vendor/jquery/jquery.ui/jquery-ui-smart-guidelines-addon.js
// module id = wExm
// module chunks = 40